// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import productReducer from './slices/productSlice';
import cartReducer from './slices/cartSlice';
import wishlistReducer from './slices/wishlistSlice';
import userReducer from './slices/userSlice';
import categoryReducer from './slices/categorySlice';
import settingReducer from './slices/settingSlice';

export const store = configureStore({
  reducer: {
    products: productReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    user: userReducer,
    categories: categoryReducer,
    settings: settingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable checks
        ignoredActions: ['categories/fetchAll/fulfilled', 'products/fetchProducts/fulfilled'],
        // Ignore these paths in the state for serializable checks
        ignoredPaths: ['categories.list', 'products.items'],
      },
    }),
});